import { render } from "./CollectionItemsPanel.vue?vue&type=template&id=3471d7a6&scoped=true"
import script from "./CollectionItemsPanel.vue?vue&type=script&lang=js"
export * from "./CollectionItemsPanel.vue?vue&type=script&lang=js"

import "./CollectionItemsPanel.vue?vue&type=style&index=0&id=3471d7a6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3471d7a6"]])

export default __exports__